import { combineReducers } from 'redux'
import auth from './auth'
import navbar from './navbar'
import layout from './layout'
import players from './players/player'
import loginhistory from './players/history'
import playerloginhistory from './players/loginhistory'
import onlineplayer from './players/online-player'
import playerreferral from './players/referral'
import playercommissionlevel from './players/commission-level'
import playerreferralrewardhistory from './players/rewardhistory'
import affiliate from './affiliates/affiliate'
import onlineaffiliate from './affiliates/online-affiliate'
import network from './affiliates/network'
import referral from './affiliates/referral'
import affiliatelevel from './affiliates/level'
import commissionlevel from './affiliates/commission-level'
import rewardhistory from './affiliates/rewardhistory'
import affiliateloginhistory from './affiliates/loginhistory'
import permissions from './permissions'
import payments from './payments'
import balances from './payments/balances'
import currencies from './payments/currencies'
import balancehistory from './payments/balancehistory'
import sportsbets from './sports/bets'
import sportslists from './sports/lists'
import sportsleagues from './sports/leagues'
import sportsbettings from './sports/bettings'
import bracketbets from './brackets/bets'
import bracketmatchs from './brackets/matchs'
import smerror from './sportsmatchs/error'
import smfinished from './sportsmatchs/finished'
import smavailable from './sportsmatchs/available'
import originalgame from './originals/game'
import originalgamehistory from './originals/history'
import casinoprovider from './casinos/provider'
import casinotype from './casinos/type'
import casinotagcategory from './casinos/tag-category'
import casinotag from './casinos/tag'
import casinolists from './casinos/casino'
import casinohistory from './casinos/history'
import casinos from './casinos/casinos'
import sportsbookprovider from './sportsbooks/provider'
import sportsbooktype from './sportsbooks/type'
import sportsbooklists from './sportsbooks/sportsbook'
import sportsbookhistory from './sportsbooks/history'
import exchange from './v2sports/history'
import p2phistory from './p2p/history'
import p2pmarkets from './p2p/market'
import colorgames from './colorgames'
import loyaltytier from './loyalty/tier'
import loyaltypoint from './loyalty/point'
import loyaltytierhistory from './loyalty/tierhistory'
import loyaltypointhistory from './loyalty/pointhistory'
import loyaltyrewardhistory from './loyalty/rewardhistory'
import promotioncampaign from './promotion/campaign'
import promotionrewardhistory from './promotion/rewardhistory'
import settinglanguage from './setting/language'
import settingword from './setting/word'
import fraudip from './fraud/ip'
import fraudfpid from './fraud/fpid'
import fraudipblacklist from './fraud/ip-blacklist'
import fraudfpidblacklist from './fraud/fpid-blacklist'

const rootReducer = combineReducers({
	auth,
	navbar,
	layout,
	originalgamehistory,
	originalgame,
	casinos,
	exchange,
	casinolists,
	casinohistory,
	casinoprovider,
	casinotype,
	casinotagcategory,
	casinotag,
	sportsbookprovider,
	sportsbooktype,
	sportsbooklists,
	sportsbookhistory,
	sportsleagues,
	sportslists,
	sportsbets,
	sportsbettings,
	bracketbets,
	bracketmatchs,
	smavailable,
	smfinished,
	smerror,
	permissions,
	currencies,
	balances,
	payments,
	balancehistory,
	loginhistory,
	players,
	onlineplayer,
	playerloginhistory,
	playerreferral,
	playercommissionlevel,
	playerreferralrewardhistory,
	affiliate,
	onlineaffiliate,
	affiliateloginhistory,
	network,
	referral,
	affiliatelevel,
	commissionlevel,
	rewardhistory,
	p2phistory,
	p2pmarkets,
	colorgames,
	loyaltytier,
	loyaltypoint,
	loyaltytierhistory,
	loyaltypointhistory,
	loyaltyrewardhistory,
	promotioncampaign,
	promotionrewardhistory,
	settinglanguage,
	settingword,
	fraudip,
	fraudfpid,
	fraudipblacklist,
	fraudfpidblacklist,
})

export default rootReducer
